export function isDocumentPictureInPictureSupported() {
    return typeof window !== 'undefined' && Boolean(window.documentPictureInPicture);
}

export function isAutomaticDocumentPictureInPictureSupported(): boolean {
    return (
        typeof window !== 'undefined' &&
        Boolean(window.documentPictureInPicture) &&
        typeof navigator.mediaSession?.setActionHandler === 'function'
    );
}
